import { render, staticRenderFns } from "./PromotionSettings.vue?vue&type=template&id=5bdb5a79&"
import script from "./PromotionSettings.vue?vue&type=script&lang=ts&"
export * from "./PromotionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports